export const pendingBookings = {
  configTitle: "Configura le prenotazioni dirette",
  configText:
    "Abilita le prenotazioni dirette per gestire da qui i pagamenti in sospeso e le richieste di prenotazione dei tuoi ospiti.",
  reminderLabel: "Promemoria:",
  reminderReasonIntent: "pagamento in sospeso da",
  reminderReasonUnassigned: "assegna la camera a",
  reminderReasonRequest: "richiesta da esaminare da",
  combined: "Combinata · {count} camere",
  expired: "Scaduta",
  toastSuccessTitle: "Operazione riuscita",
  toastErrorTitle: "Errore",
  toastWarningTitle: "Avviso",
};
